var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"form-section"},[_c('header',{staticClass:"form-section-head"},[_c('h5',{staticClass:"form-section-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"form-section-desc"},[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }